import { Dialog } from '@mui/material';
import React from 'react';
import { ReactComponent as CrossIcon } from "../../../../../../../assets/img/svg/CrossIcon.svg"
import AButton from '../../../../common/form-fields-mui/AButton';
import styles from "../styles.module.scss"
// import { validateSequencing } from '../../utils';
import { useGetCollectPaymentContext } from '../../context';

const VerifyDetailsDialog = ({ open, closeHandler, confirmHandler, module }) => {
    const { selectedChargesAmount, studentBasicDetails,selectedCharges,partialAddAmount , validateSequencing} = useGetCollectPaymentContext(module);
    return (
        <Dialog
            open={open}
            maxWidth="xs"
        >
            <div className={styles['dialog-padding']}>

                <div className='d-flex justify-content-between'>
                    <div className={styles['verify-details-dialog-header']}>
                        Please confirm that student, Course and Payment details are correct.
                    </div>
                    <CrossIcon className={styles['dialog-cross-icon']} onClick={closeHandler} />
                </div>

                <div className='d-flex justify-content-between mt-3'>
                    <AButton
                        variant='outline'
                        onClick={closeHandler}
                        className='no-ml-btn'
                    >
                        No, Go Back
                    </AButton>

                    <AButton
                        variant='outline'
                        onClick={()=>{
                            validateSequencing(studentBasicDetails,selectedCharges,(partialAddAmount||selectedChargesAmount));
                             confirmHandler()
                            }}
                    >
                        Yes, Confirm
                    </AButton>

                </div>

            </div>
        </Dialog>
    );
}

export default VerifyDetailsDialog;